import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';

const BillingDate = ({
    registrationIdsSelected
}) => {
    const [idItem, setIdItem] = useState(null);
    const [billingDate, setDsBillingDate] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [billingDateIdSelected, setBillingDateIdSelected] = useState([]);
    const [yearFilter, setYearFilter] = useState(new Date);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "billingDate", value: billingDate, setter: setDsBillingDate },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, yearFilter]);

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!billingDateIdSelected || billingDateIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!billingDateIdSelected || billingDateIdSelected.length > 1) {
            setBillingDateIdSelected([])
        }
    }, [billingDateIdSelected, updating]);


    useEffect(() => {
        if (billingDateIdSelected && billingDateIdSelected.length === 1) {
            fetchDataDetail(billingDateIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [billingDateIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        const parameters = { yearSelected: yearFilter }
        const items = await ExecuteAxios.api('get', `/billing-date/get-billing-date-grid/`, { params: parameters });
        setRecordsItemByUserId(items);
        RemoveIdsNotFound.remove(items, setBillingDateIdSelected, billingDateIdSelected)
    }

    const fetchDataDetail = async (billingDateIdSelected) => {
        const parameters = { id: billingDateIdSelected ? billingDateIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/billing-date/get-billing-date-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!billingDateIdSelected || billingDateIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setBillingDateIdSelected}
                    idsSelected={billingDateIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/billing-date/`, {
                billingDate: billingDate,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }
            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }


    async function deleteFunction() {
        try {
            setLoadingItemPanel(true)

            const response = await ExecuteAxios.api('delete', `/billing-date/`, {
                params: { ids: billingDateIdSelected.join(",") }
            });

            if (response) {
                await reloadListItem()
            }
            return response
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/billing-date/`, {
                id: idItem,
                billingDate: billingDate,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }
    const styleComboBoxYear = {
        display: 'flex',
        flexDirection: 'row',
        width: '60px',
        marginLeft: '10px',
        alignItems: 'center',
        alignItems: 'center'
    }

    function componentRightFilterYear() {
        return (
            <Panel style={styleComboBoxYear}>
                <ReactDataPickerComp
                    selected={yearFilter}
                    onChange={(date) => { setYearFilter(date) }}
                    wrapperClassName={'width-full'}
                    className='validate-attribute width-full cursor-pointer'
                    dateFormat={'yyyy'}
                    showYearPicker={true}
                    setter={setYearFilter}
                />
            </Panel>
        )
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Data faturamento'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={billingDateIdSelected && billingDateIdSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={billingDateIdSelected}
                viewOnlyOneRecordCRUD={true}
                deleteFunction={deleteFunction}
                canDelete={true}
                enableDelete={billingDateIdSelected && billingDateIdSelected.length >= 1}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setBillingDateIdSelected}
                componentRightFilter={componentRightFilterYear()}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default BillingDate;